import React from 'react'
import Icon from 'react-icon-base'

export default (props) => {
  return (
    <Icon viewBox='0 0 512 512' {...props}>
      <title id='Play'>{props.title || 'Play'}</title>
      <g><path d='M255.5 5C116.6 5 4 117.6 4 256.5 4 395.41 116.6 508 255.5 508S507 395.4 507 256.5 394.4 5 255.5 5m119.3 264.99l-172.98 98.6c-13.03 7.44-23.69 1.36-23.69-13.48V157.9c0-14.84 10.66-20.91 23.69-13.49L374.8 243c13 7.43 13 19.57 0 26.99' /></g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/play.js